// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".special-menu-header[data-v-f492c2be]{align-items:center;display:flex;flex:auto;padding:0 1rem;-webkit-text-decoration:none;text-decoration:none;width:10rem}@media (min-width:992px){.special-menu-header[data-v-f492c2be]{width:8rem}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
